export enum UserGroupsEnum {
  SPAS_Admin = 'Admin',
  SPAS_CBMLead = 'CBMLead',
  SPAS_RCALead = 'RCALead',
  SPAS_Operator = 'Operator',
  SPAS_Guest = 'Guest',
  SPAS_Configurator = 'Configurator',
}
